<template>
    <b-row class="flex-row-reverse" no-gutters>
        <b-spinner small v-if="isLoading" class="float-right mx-3"></b-spinner>
        <span v-else class="float-right font-weight-bold mx-3">Situação: {{ situacao }}</span>
    </b-row>
</template>
<script lang="ts">
import { UtilsTS } from '@/utilsts';
import { eventBus } from '@/main';
import { mixins } from 'vue-class-component';
import { Component, Vue, Watch } from 'vue-property-decorator';
import ldiService from '@/services/licitacoes/ldiService'

const CompProps = Vue.extend({
    name: 'SituacaoLicitacao',
    props: {
        idLicitacao: {
            type: Number,
        }
    }
})
@Component
export default class SituacaoLicitacao extends mixins(UtilsTS, CompProps) {
    isLoading = true
    situacao = ''

    created() {
        this.recarregar()
        eventBus.$on('atualizar-status-licitacao', this.recarregar)
    }
    destroyed() {
        eventBus.$off('atualizar-status-licitacao', this.recarregar)
    }
    @Watch('idLicitacao')
    atualizar(newv) {
        if (newv > 0) this.recarregar()
    }

    async recarregar(novaSituacao: string | null = null) {
        try {
            if (!this.idLicitacao) return this.situacao = 'Não cadastrada'
            if (novaSituacao) return this.tratarRetorno(novaSituacao)
            this.isLoading = true
            this.tratarRetorno(await ldiService.buscarSituacao(this.idLicitacao))
        } catch (e: any) {
            console.error('Falha ao obter a situação da licitação', e)
            this.situacao = ''
        } finally {
            this.isLoading = false
        }
    }

    //TODO: Centralizar isto. É usado aqui, em licitacao-resumida.ts e em licitacao.ts
    tratarRetorno(retorno: string): void {
        switch (retorno) {
            case "EM":
                this.situacao = "Em Cadastramento";
                break;
            case "LI":
                this.situacao = "Finalizada";
                break;
            case "AN":
                this.situacao = "Anulada";
                break;
            case "RE":
                this.situacao = "Revogada";
                break;
            case "DE":
                this.situacao = "Deserta";
                break;
            case "FR":
                this.situacao = "Fracassada";
                break;
            case "JE":
                this.situacao = "Já Existente";
                break;
            case "NA":
                this.situacao = "Não Adicionada";
                break;
            default:
                this.situacao = '';
                break;
        }
    }
}
</script>